export default __webpack_public_path__ + "static/media/kits-de-sincronismo-534x444.0ee750a9.jpg";